/**
 * BLOCKED USERS ARE NOT OFFERED (user directive 2026-09-20: "in analytics,
 * assignation, reports, ranking I don't want them to see").
 *
 * `isBlocked` is the HARD ban — the user cannot sign in (`auth.service.ts`)
 * and cannot be assigned (`assignment.policies.ts`). Listing them in a picker
 * or ranking them against people who can work is noise.
 *
 * They deliberately REMAIN in User management and Role management, which is
 * where you unblock them — so this is applied at the picker, never by
 * stripping the roster the management screens read.
 *
 * Deactivated users (`isActive === false`) are a SEPARATE, softer state and
 * are not touched here: the assign panel has its own Active/Inactive/All
 * switch over them.
 */
export function isBlockedUser(user: unknown): boolean {
  return (user as { isBlocked?: unknown } | null)?.isBlocked === true;
}

/** Drop hard-banned users from a picker list. */
export function excludeBlockedUsers<T>(users: readonly T[] | undefined): T[] {
  return (users ?? []).filter((u) => !isBlockedUser(u));
}
